import {INIT_URL, SIGNOUT_USER_SUCCESS, USER_DATA, USER_TOKEN_SET, SIDE_NAV_SET, TF_AUTH, USER_EMAIL, OTP_INVALID} from "../constants/ActionTypes";

const INIT_STATE = {
  token: JSON.parse(localStorage.getItem('token')),
  initURL: '',
  authUser: JSON.parse(localStorage.getItem('user')),
  tfAuth: false,
  userEmail: null,
  otpInvalid : false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case INIT_URL: {
      return {...state, initURL: action.payload};
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        initURL: ''
      }
    }

    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload,
      };
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }

    case SIDE_NAV_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }

    case TF_AUTH: {
      return {
        ...state,
        tfAuth: action.payload
      };
    }

    case USER_EMAIL: {
      return {
        ...state,
        userEmail: action.payload
      };
    }

    case OTP_INVALID: {
      return {
        ...state,
        otpInvalid: action.payload
      };
    }

    default:
      return state;
  }
}
